import {Button, Stack} from '@mui/material';
import React, {Fragment} from 'react';
import {useNavigate} from 'react-router-dom';

import {AlertModal} from 'presentation/components';
import {ProfileEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {ConfirmSubscriptionDialogProps} from './types';
import {StyledDescription, StyledLink} from './styles';
import {BillsTaggingEnum} from 'main/analytics/gaTagsEnum';

const {confirmSubscriptionDialog} = translations['pt-br'].privateFlow.home;

export function ConfirmSubscriptionDialog({
	onPrimaryAction,
	onSecondaryAction,
	onCloseModal,
	open,
	email,
	disabled,
	isBemobiFlow = false,
}: ConfirmSubscriptionDialogProps) {
	const navigate = useNavigate();
	const title = isBemobiFlow
		? confirmSubscriptionDialog.titleBemobi
		: confirmSubscriptionDialog.title;
	const line1 = isBemobiFlow
		? confirmSubscriptionDialog.line1Bemobi
		: confirmSubscriptionDialog.line1;

	return (
		<AlertModal
			headerDataTagId={BillsTaggingEnum.VISUALIZOU_MODAL_ADESAO_BOLETO}
			closeBtnDataTagId={BillsTaggingEnum.CLICK_FECHAR_MODAL_ADESAO_BOLETO}
			variant="primary"
			customIconName="receipt-long-filled"
			headerTitle={confirmSubscriptionDialog.header}
			title={title}
			open={open}
			onClose={onCloseModal}
			subDescription={
				<Fragment>
					<StyledDescription>
						{line1}
						<b>{email}</b>
						{confirmSubscriptionDialog.line2}
					</StyledDescription>
					<StyledDescription>
						{confirmSubscriptionDialog.line3}
						<StyledLink
							variant="body2"
							color="primary.main"
							onClick={() => navigate(ProfileEnum.PROFILE)}>
							{`${confirmSubscriptionDialog.profileLink}.`}
						</StyledLink>
					</StyledDescription>
				</Fragment>
			}
			footerContent={
				<Stack gap={1} width="100%">
					<Button
						disabled={disabled}
						type="submit"
						size="large"
						data-test="confirm-new-contact"
						onClick={onPrimaryAction}
						data-tag-id={BillsTaggingEnum.CLICK_CONFIRMAR_ADESAO_BOLETO}
						fullWidth>
						{confirmSubscriptionDialog.confirmButton}
					</Button>
					<Button
						fullWidth
						variant="outlined"
						onClick={onSecondaryAction}
						size="large"
						data-tag-id={BillsTaggingEnum.CLICK_CANCELAR_ADESAO_BOLETO}>
						{confirmSubscriptionDialog.cancelButton}
					</Button>
				</Stack>
			}
		/>
	);
}
